import { EnvConfig } from "./envconfig";

export const environment: EnvConfig = {
  production: true,
  sbdBaseUrl: 'https://staging-ap-dev.suretybondsdirect.com',
  apiBaseUrl: 'https://account-portal-api-staging-ap-dev.suretybondsdirect.com',
  dougV2BaseUrl: 'https://staging-ap-dev.suretybondsdirect.com',
  apiLocalUrl: 'https://account-portal-api-staging-ap-dev.suretybondsdirect.com/v4',
  titleBase: '(APDEV) Account Portal',
  shouldCathyBeChatty: true,
  reCaptchaSiteKey: '6Lf1vxYqAAAAABdGAN_tEUhdlYlLwAWKUpREW84x'
};
